import React, {useEffect, useState} from 'react';
import { CatalogProducts, SemSettings, GuestUserCreation } from "../../../../js/services/loggedout-api"
import ProductPlans from "../../../../js/screens/purchase/product-list.js"
import connect from '../../../../js_bytesize/config/purchase/connect';
import { useSelector } from 'react-redux';

import { SetActiveCourse } from '../../../services/student-api';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { TrackUserActionAnalytics } from '../../../services/loggedout-api';
import OnboardingAnimation from './purchase-complete-animation';


const PurchasePage = ({
	initialize,
  products,
  goToNextHandler,
  currentUser,
}) => {
	const { selectedGrade, selectedSubject } = useSelector(state => {
		return {
			selectedGrade: state.selectedGrade,
      childScreenName: state.childScreenName,
      selectedSubject: state.selectedSubject,
		}
	});
  const [isLoading, setOnPurchaseLoader] = useState(false);
  const { deleteAll } = useExtendedLocalStorage('splashverse-onboarding', '');
  const paymentSuccessHandler = async (email, skipClearStorage) => {
      if(email){
        await GuestUserCreation({
          user: {
            type: "parent",
            email,
          },
          rejectWithErrorObject: true,

        }, true);
      }

      setOnPurchaseLoader(true);
      SetActiveCourse({
        subject_code: selectedSubject,
        onboarding: true,
        password_not_set: true,
        // lp_ab_test: isLPABTest,     // BE do onboarding based on this condition for LPABTest
      }, true);

      !skipClearStorage && deleteAll();

  }

  const getCatalogProducts = async () => {
    const settingsParam = {"variant": "0"}
    const semSettings = await SemSettings(settingsParam);

    let settings = {
      coupon: null,
      couponRedeemable:null,
      is_sem_landing_user:false,
      skipSignUp: true,
      trialAvailable: true,
      video_on_cross_enabled: false,
      current_user:null,
      isSemUser: false,
      trailDays: 7,
      showMoneyBack: true,
      show_refund_widget: true,
      withoutCC : null,
      showPromoPage : false,
      showPromoInputField : false,
      campaignCode : undefined,
      showPromoPopup : false,
      stripeCards: [],
      grade_code: selectedGrade,
      show_combined_landing_page_for_plan_page: true
    }
    settings = { ...settings, ...semSettings, currentUser}
    const productParams = {"variant": "0", "grade_code": selectedGrade, preferred_language: settings.preferred_language}
    const products = await CatalogProducts(productParams);
    initialize({products: products.products,settings: {...settings}})
  }

  useEffect(() => {
    try {
      getCatalogProducts();
      TrackUserActionAnalytics({
        user_action: 'plan_page_shown',
        action_info: {
          grade_code: selectedGrade,
          subject_code: selectedSubject,
        }
      }, true)
    } catch (e) {
      console.log(e);
    }
	},[])

  const sendAnalytics = (name, properties) => {
    var eventProperties = {
      'Via Onboarding': true
    }
    eventProperties['Parent Signup Present'] = false;
    if(!name){
      name = "Visited Product List";
    }

    properties = properties || {};

    Object.keys(properties).map(function(key){ eventProperties[key] = properties[key]});
    trackAnalyticsEvent(name, eventProperties);
  }

  return (
    <div>
      {products && products.length != 0 &&
        <>
          { isLoading ?
            <OnboardingAnimation/> :
            <ProductPlans sendAnalytics={sendAnalytics} skipSignUp = {true} paymentSuccessHandlerForSVTrial={paymentSuccessHandler} goToNextHandler={goToNextHandler} />
          }
        </>
      }
    </div>
  )
}

function mapStateToProps(state) {
  return {
    settings: state.settings,
    products: state.products
  }
}

function mapDispatchToProps(dispatch) {
  return {
    initialize: (data) => dispatch({type: "INITIALIZE", payload: data}),
    setParams: (data) => dispatch({type: 'SET_PARAMS', payload: data})
  }
}

export default connect(mapStateToProps, mapDispatchToProps, PurchasePage);
